import { render, staticRenderFns } from "./ProduitContent.vue?vue&type=template&id=5ccba288&scoped=true&"
import script from "./ProduitContent.vue?vue&type=script&lang=js&"
export * from "./ProduitContent.vue?vue&type=script&lang=js&"
import style0 from "./ProduitContent.vue?vue&type=style&index=0&id=5ccba288&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccba288",
  null
  
)

export default component.exports